function getFieldError(error: unknown): string | undefined {
  if (typeof error === "string") {
    return error;
  }

  if (error && typeof error === "object" && "message" in error) {
    return (error as { message: string }).message;
  }

  return undefined;
}

export { getFieldError };
